import { useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import WebhookList from './components/WebhookList';
import WebhookEditor from './components/WebhookEditor';

apiFetch.use( apiFetch.createNonceMiddleware( window.rtwcAdmin?.nonce ) );

export default function App() {
	const [ view, setView ]       = useState( 'list' ); // 'list' | 'edit'
	const [ editId, setEditId ]   = useState( null );   // null = new
	const [ webhooks, setWebhooks ] = useState( [] );
	const [ loading, setLoading ] = useState( true );
	const [ notice, setNotice ]   = useState( null );   // { type: 'success'|'error', text }

	const showNotice = ( type, text ) => {
		setNotice( { type, text } );
		setTimeout( () => setNotice( null ), 4000 );
	};

	const loadWebhooks = async () => {
		setLoading( true );
		try {
			const data = await apiFetch( { path: '/rtwc/v1/webhooks' } );
			setWebhooks( data );
		} catch ( e ) {
			showNotice( 'error', 'Failed to load webhooks.' );
		} finally {
			setLoading( false );
		}
	};

	useEffect( () => { loadWebhooks(); }, [] );

	const handleNew = () => {
		setEditId( null );
		setView( 'edit' );
	};

	const handleEdit = ( id ) => {
		setEditId( id );
		setView( 'edit' );
	};

	const handleDelete = async ( id ) => {
		if ( ! window.confirm( 'Delete this webhook?' ) ) return;
		try {
			await apiFetch( { path: `/rtwc/v1/webhooks/${ id }`, method: 'DELETE' } );
			showNotice( 'success', 'Webhook deleted.' );
			loadWebhooks();
		} catch {
			showNotice( 'error', 'Delete failed.' );
		}
	};

	const handleSaved = () => {
		showNotice( 'success', 'Webhook saved successfully!' );
		loadWebhooks();
		setView( 'list' );
	};

	const handleBack = () => setView( 'list' );

	return (
		<div className="rtwc-app">
			<div className="rtwc-header">
				<div className="rtwc-header-inner">
					<span className="dashicons dashicons-rest-api rtwc-header-icon" />
					<h1>RTWC Webhooks</h1>
					{ view === 'list' && (
						<button className="button button-primary rtwc-new-btn" onClick={ handleNew }>
							+ Add New Webhook
						</button>
					) }
					{ view === 'edit' && (
						<button className="button rtwc-back-btn" onClick={ handleBack }>
							← Back to List
						</button>
					) }
				</div>
			</div>

			{ notice && (
				<div className={ `rtwc-notice rtwc-notice--${ notice.type }` }>
					{ notice.text }
				</div>
			) }

			<div className="rtwc-body">
				{ view === 'list' && (
					<WebhookList
						webhooks={ webhooks }
						loading={ loading }
						onEdit={ handleEdit }
						onDelete={ handleDelete }
						onNew={ handleNew }
					/>
				) }
				{ view === 'edit' && (
					<WebhookEditor
						webhookId={ editId }
						onSaved={ handleSaved }
						onCancel={ handleBack }
						showNotice={ showNotice }
					/>
				) }
			</div>
		</div>
	);
}
